"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsControlsColorSpecification_1 = __importDefault(require("../typeAssertions/valueIsControlsColorSpecification"));
const valueIsMapsLatLng_1 = __importDefault(require("../typeAssertions/valueIsMapsLatLng"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const getNumberFromUnknown_1 = __importDefault(require("./getNumberFromUnknown"));
const castNumberToCoordinate_1 = __importDefault(require("./castNumberToCoordinate"));
const linearRouteCalculator = (getColorFromSpecification) => (rawRoute) => {
    if ((0, valueIsArray_1.default)(rawRoute)) {
        const coordinates = rawRoute.filter(valueIsMapsLatLng_1.default);
        if (coordinates.length > 0) {
            return {
                coordinates,
                color: 'red',
                width: 2,
            };
        }
    }
    if (!(0, valueIsRecord_1.default)(rawRoute)) {
        return undefined;
    }
    const { origin: rawOrigin, destination: rawDestination } = rawRoute;
    if (!(0, valueIsRecord_1.default)(rawOrigin) || !(0, valueIsRecord_1.default)(rawDestination)) {
        return undefined;
    }
    const origin = Object.assign(Object.assign({}, rawOrigin), { latitude: (0, castNumberToCoordinate_1.default)(rawOrigin.latitude), longitude: (0, castNumberToCoordinate_1.default)(rawOrigin.longitude) });
    const destination = Object.assign(Object.assign({}, rawDestination), { latitude: (0, castNumberToCoordinate_1.default)(rawDestination.latitude), longitude: (0, castNumberToCoordinate_1.default)(rawDestination.longitude) });
    if (!(0, valueIsMapsLatLng_1.default)(origin) || !(0, valueIsMapsLatLng_1.default)(destination)) {
        return undefined;
    }
    let color = 'red';
    if ((0, valueIsString_1.default)(rawRoute.color)) {
        color = rawRoute.color;
    }
    else if ((0, valueIsControlsColorSpecification_1.default)(rawRoute.color)) {
        const computedColor = getColorFromSpecification(rawRoute.color);
        if (computedColor) {
            color = computedColor;
        }
    }
    const width = (0, getNumberFromUnknown_1.default)((rawRoute === null || rawRoute === void 0 ? void 0 : rawRoute.width) || 2);
    return {
        coordinates: [origin, destination],
        color,
        width,
    };
};
const linearRoutesCalculator = (getColorFromSpecification) => (rawRoutes) => {
    if ((0, valueIsRecord_1.default)(rawRoutes)) {
        return Object.entries(rawRoutes)
            .reduce((lines, [routeKey, rawRoute]) => {
            const route = linearRouteCalculator(getColorFromSpecification)(rawRoute);
            if (!route) {
                return lines;
            }
            return Object.assign(Object.assign({}, lines), { [routeKey]: route });
        }, {});
    }
    if ((0, valueIsArray_1.default)(rawRoutes)) {
        return rawRoutes.reduce((lines, rawRoute, index) => {
            const route = linearRouteCalculator(getColorFromSpecification)(rawRoute);
            if (!route) {
                return lines;
            }
            return Object.assign(Object.assign({}, lines), { [`i${index}`]: route });
        }, {});
    }
    return {};
};
exports.default = linearRoutesCalculator;
